import { combineReducers, configureStore } from '@reduxjs/toolkit'
import constantsReducer from './constantsSlice'
import userReducer from './userSlice'
import rightSidebarSlice from '@/lib/redux/rightSidebarSlice'
import companyReducer from './companySlice'
import uiReducer from './uiSlice'

const rootReducer = combineReducers({
  constants: constantsReducer,
  user: userReducer,
  rightSidebar: rightSidebarSlice,
  company: companyReducer,
  ui: uiReducer,
})

export function makeStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  })
}

export type AppStore = ReturnType<typeof makeStore>
export type AppDispatch = AppStore['dispatch']
export type RootState = ReturnType<typeof rootReducer>
